fragment UserGroupFields on UserGroup {
  id
  _rowTimestamp
  _isUpdatable
  _isDeletable
  name
  description
  isAccessOnlyToCreatedRows
}
